import { AccountInfo, LogLevel, PublicClientApplication } from "@azure/msal-browser";

let msalSimDocumentsInstance: PublicClientApplication | undefined;
let msalSimInstance: PublicClientApplication | undefined;


// Factory function to create msalConfig after config is loaded
export function getMsalConfig() {
    return {
        auth: {
            clientId: process.env.REACT_APP_SIM_DOCUMENTS_ENV_APP_REGISTRATION!,
            authority: "https://login.microsoftonline.com/556e6b1f-b49d-4278-8baf-db06eeefc8e9",
            redirectUri: process.env.REACT_APP_REDIRECT_URL
        },
        cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: false,
        },
        system: {
            loggerOptions: {
                loggerCallback: (level: LogLevel, message: any, containsPii: any) => {
                    if (containsPii) return;
                    switch (level) {
                        case LogLevel.Error: console.error(message); return;
                        case LogLevel.Warning: console.warn(message); return;
                        default: return;
                    }
                }
            }
        }
    };
}

export function getMsalSimConfig() {
    return {
        auth: {
            clientId: process.env.REACT_APP_SIM_ENV_APP_REGISTRATION!,
            authority: "https://login.microsoftonline.com/556e6b1f-b49d-4278-8baf-db06eeefc8e9",
            redirectUri: process.env.REACT_APP_REDIRECT_URL
        },
        cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: false,
        },
        system: {
            loggerOptions: {
                loggerCallback: (level: LogLevel, message: any, containsPii: any) => {
                    if (containsPii) return;
                    switch (level) {
                        case LogLevel.Error: console.error(message); return;
                        case LogLevel.Warning: console.warn(message); return;
                        default: return;
                    }
                }
            }
        }
    };
}

// Factory functions for instances
export function createMsalSimDocumentsInstance() {
    msalSimDocumentsInstance =  new PublicClientApplication(getMsalConfig());
    return msalSimDocumentsInstance;
}
export function createMsalSimInstance() {
    msalSimInstance = new PublicClientApplication(getMsalSimConfig());
    return msalSimInstance
}

// Requests
export function getSilentSimRequest(account: AccountInfo) {
    return {
        scopes: [process.env.REACT_APP_SIM_SCOPE!],
        account: account,
        forceRefresh: false
    };
}

export function getSilentSimDocumentsRequest(account: AccountInfo) {
    return {
        scopes: [process.env.REACT_APP_SIM_DOCUMENTS_SCOPE!],
        account: account,
        forceRefresh: false
    };
}

// Accessor functions
export function getMsalSimDocumentsInstance() {
  if (!msalSimDocumentsInstance) throw new Error("MSAL Sim Documents instance not initialized");
  return msalSimDocumentsInstance;
}
export function getMsalSimInstance() {
  if (!msalSimInstance) throw new Error("MSAL Sim instance not initialized");
  return msalSimInstance;
}

export async function initializeMsalSimDocumentsInstance() {
    await getMsalSimDocumentsInstance().initialize()
}

export async function initializeMsalSimInstance() {
    await getMsalSimInstance().initialize()
}

export const loginRequest = { scopes: ["User.Read"] };
export const graphConfig = { graphMeEndpoint: "https://graph.microsoft.com/User.Read" };